export const HYPERLINK_RELATIONSHIP_TYPE =
  'http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink';
export const HEADER_RELATIONSHIP_TYPE = 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/header';
export const FOOTER_RELATIONSHIP_TYPE = 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/footer';

/** Bare filenames for all OOXML comment support parts */
export const COMMENT_FILE_BASENAMES = [
  'comments.xml',
  'commentsExtended.xml',
  'commentsIds.xml',
  'commentsExtensible.xml',
];

/** Standard XML declaration used for all OOXML parts */
export const DEFAULT_XML_DECLARATION = Object.freeze({
  attributes: Object.freeze({
    version: '1.0',
    encoding: 'UTF-8',
    standalone: 'yes',
  }),
});

// Comment-related relationship types (used for pruning stale rels on export)
export const COMMENT_RELATIONSHIP_TYPES = new Set([
  'http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments',
  'http://schemas.microsoft.com/office/2011/relationships/commentsExtended',
  'http://schemas.microsoft.com/office/2016/09/relationships/commentsIds',
  'http://schemas.microsoft.com/office/2018/08/relationships/commentsExtensible',
]);
